import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import SuiteApi from "../../api/SuiteApi";
import UserApi from "../../api/UserApi";
import IconApp from "../../Icons/AppIcon";
import { ApplicationInfo } from "../../Model/ApplicationInfo";
import MtiButton from "../Buttons/MtiButton";
import TextBox from "../Common/TextBox";
import "./Login.css";
import { useDispatch } from "react-redux";
import { removeNotification } from "../../redux/actions/NotificationAction";
import Loading from "../../Loading";
import { ENotificationType } from "../../Model/ENotificationType";
import Notification from "../Common/Notification";
import { useTypedSelector } from "../../redux/reducers/RootReducer";
import { getNotifications } from "../../redux/reducers/NotificationReducer";

export default function ForgotPassword() {
  const dispatch = useDispatch();
  const [userName, setUserName] = useState("");
  const [showLoading, setShowLoading] = useState(false);
  const history = useHistory();
  const [instrumentTypeName, setInstrumentTypeName] = useState("ROCK IMAGER");
  const [applicationInfo, setApplicationInfo] = useState({} as ApplicationInfo);
  const [disableButton, setDisableButton] = useState(false);
  const notifications = useTypedSelector((state) => getNotifications(state));
  const notification = notifications[0];

  useEffect(() => {
    SuiteApi.getInstrumentTypeName().then((value) => {
      setInstrumentTypeName(value);
    });
    SuiteApi.getApplicationInfo().then((value) => {
      setApplicationInfo(value);
    });
  }, []);

  const onEnterKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      proceed();
    }
  };
  const resetFailStatus = () => {};

  const onNotificationClosed = () => {
    dispatch(removeNotification());
    setDisableButton(false);
  };

  const cancel = () => {
    history.push("/");
  };

  const proceed = () => {
    setShowLoading(true);
    setDisableButton(true);
    UserApi.requestOtp({
      userName: userName,
    })
      .then(() => {
        setShowLoading(false);
        history.push("/reset-password/success");
      })
      .catch((error) => {
        setShowLoading(false);
      });
  };

  return (
    <>
      {showLoading && <Loading />}
      <div className="login-page">
        <div
          className="login-form"
          style={{
            width: "600px",
          }}
        >
          <div className="login-title">
            <div className="title-container">
              <IconApp width="34" height="34" viewBox="0 0 48 48" fill="none" />
              <p>
                {instrumentTypeName}
                <sup>®</sup>
              </p>
            </div>
          </div>
          <span>Enter your username or email address to reset password</span>
          <TextBox
            name="Username"
            value={userName}
            placeHolder="Username / Email Address"
            onKeyDown={(event) => setUserName(event.currentTarget.value)}
            onChange={(value) => setUserName(value as string)}
            onClick={resetFailStatus}
            onKeyPress={onEnterKeyPress}
            supportAutoFill={true}
          />

          <div className="login-buttons">
            <MtiButton
              size="large"
              onClick={proceed}
              disabled={userName.trim().length === 0 || disableButton}
            >
              Proceed
            </MtiButton>
            <MtiButton
              size="large"
              onClick={cancel}
              style={{
                margin: "0px 10px",
              }}
              disabled={disableButton}
            >
              Cancel
            </MtiButton>
          </div>
        </div>
        <div
          className="login-footer"
          style={{
            width: "600px",
          }}
        >
          <div>
            <p>{"version " + applicationInfo.productVersion}</p>
          </div>
          <div>
            <p>{applicationInfo.companyName}</p>
          </div>
          <div>
            <p>{`©${applicationInfo.copyrightYear}`}</p>
          </div>
        </div>
      </div>
      <Notification
        type={notification?.type ?? ENotificationType.Info}
        active={notification != null}
        message={notification?.message}
        onClose={onNotificationClosed}
      />
    </>
  );
}
